module.exports = __webpack_public_path__ + "img/paypallogo.a03d6ffb.png";